<div>
  <div class="close-btn d-flex justify-content-end p-1 pt-2">
    <button
      mat-icon-button
      mat-dialog-close
      (click)="close()"
      class="col-auto"
      appTrackClick="images-viewer-close-btn"
    >
      <mat-icon fontSet="material-icons-outlined" class="primary-color"
        >cancel</mat-icon
      >
    </button>
  </div>
  @if (images.length) {
    <div id="carouselIndicators" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        @for (img of images; track img; let i = $index) {
          <div class="carousel-item bag-img" [ngClass]="{ active: i == 0 }">
            <div
              class="iv-img-box d-flex justify-content-center align-items-center px-3 pb-3"
              [class.iv-img-box--placeholder]="img.noImage"
            >
              <img
                [class.img]="!img.noImage"
                [class.iv-img-box__placeholder-icon]="img.noImage"
                [src]="img.url ? img.url : 'assets/bag.svg'"
              />
            </div>
            <div class="row justify-content-center">
              @if (img.barcode) {
                <div class="col-md-6 col-sm-8 col-xs-10 col-12 mt-3">
                  <div class="iv-barcode-row">
                    <mat-icon class="iv-barcode-row__icon"
                      >qr_code_scanner</mat-icon
                    >
                    <div>
                      <div class="secondary-text fs-12" translate>
                        Bag Barcode
                      </div>
                      <div class="fw-600 fs-14">
                        {{ img.barcode | numberTranslate }}
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
      @if (images.length > 1) {
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselIndicators"
          data-bs-slide="prev"
        >
          <span aria-hidden="true">
            <mat-icon fontSet="material-icons-outlined"
              >arrow_circle_left</mat-icon
            >
          </span>
          <span class="visually-hidden">Previous</span>
        </button>
      }
      @if (images.length > 1) {
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselIndicators"
          data-bs-slide="next"
        >
          <span aria-hidden="true">
            <mat-icon fontSet="material-icons-outlined"
              >arrow_circle_right</mat-icon
            >
          </span>
          <span class="visually-hidden">Next</span>
        </button>
      }
    </div>
  }
</div>
